<template>
  <div class="overflow-hidden">
    <header class="w-full xl:w-[1200px] mx-auto h-20 flex items-center relative">
      <HeaderBox />
    </header>
    <div class="">
      <section class="hero relative overflow-hidden pt-12 lg:pt-20 pb-1">
        <div style="z-index: -1" class="absolute -top-56 -right-10">
          <img src="./assets/blur.svg?url" />
        </div>
        <div class="l-container">
          <div class="text-center flex flex-col-reverse lg:text-left lg:grid grid-cols-2 gap-8 items-center">
            <div class="">
              <h1 class="heading level-2">
                Work fast, smart, <br /> and stress-free with Eazipay
              </h1>
              <div class="w-full flex flex-col sm:gap-2 pt-14">
                <h2 class="text-black heading text-5xl font-semibold"> Instant Salary Advance</h2>
                <ul class="pt-2">
                  <li v-for="item in instantSalary" :key="item" class="flex gap-x-2 py-2 items-start">
                    <img src="../eazi-landing/assets/circle-check.svg?url" alt="check" class="block mt-1">
                    <span class="text-[18px] xl:text-xl">{{ item }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="max-w-xl mx-auto">
              <img src="./assets/asset1.png" />
            </div>
          </div>



          <div :class="{
            'flex items-center overflow-x-hidden': true,
            relative: isInfinite,
          }"></div>

          <div class="my-10 md:mb-6">
            <div class="hidden md:flex items-center gap-4 font-semibold text-[16px] xl:text-[18px]">
              <IconCard v-for="(item, i) in infoList" :key="`info-${i}`" :title="item.title" :color="item.color" />
            </div>

            <InfinitScrollVue class="md:hidden">
              <IconCard v-for="(item, i) in infoList" :key="`info-${i}`" :title="item.title" :color="item.color" />
            </InfinitScrollVue>
          </div>

          <div>
            <p class="text-black w-4/5 text-xl mx-0 mb-6">
              Less financial stress means higher focus, better performance, and happier teams. <br> Ready to empower
              your team?

            </p>
            <a href="https://www.myeazipay.com/register?page=1" class="link-btn w-[260px]">
              Activate Salary Advance Now
            </a>
            <!-- <SiteButton color="primary" to="https://www.myeazipay.com/register?page=1">
              Activate Salary Advance Now
            </SiteButton> -->
          </div>

        </div>
      </section>

      <section class="filing-section py-12 lg:py-20 mt-10">
        <div class="l-container">
          <div class="flex flex-col lg:grid grid-cols-2 lg:gap-16 items-center">
            <div>
              <img src="./assets/asset2.png" />
            </div>
            <div class="max-w-md mx-auto mb-10 lg:mb-0 lg:max-w-none text-left">
              <h2 class="heading font-semibold text-5xl mb-4">Personal Credit Card</h2>
              <div class="flex flex-col gap-5 mt-3">
                <p class="text-xl text-black">
                  Power, flexibility, and control — right in your pocket.
                  Designed for CEOs and senior management, your Personal Credit Card gives you 30 days of spending
                  freedom. No interest, No hidden fees, No monthly loan application.
                </p>
                <ul class="">
                  <li v-for="item in personalCredit" :key="item" class="flex gap-x-2 py-2 items-center">
                    <img src="../eazi-landing/assets/circle-check.svg?url" alt="check" class="block">
                    <span class="text-[18px] xl:text-xl">{{ item }}</span>
                  </li>
                </ul>

                <p class="text-black text-[18px] xl:text-xl italic">
                  "Stop waiting in line. Start leading with ease."
                </p>

                <div class="w-[300px]">
                  <a href="https://www.myeazipay.com/register?page=1" class="link-btn w-[240px]">
                    Activate your card today
                  </a>
                  <!-- <SiteButton color="primary" shadow to="/register?page=1">
                    Activate your card today
                  </SiteButton> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="bg-white py-12 lg:py-12">
        <div class="l-container">
          <div class="flex flex-col lg:grid grid-cols-2 lg:gap-16 items-center">
            <div class="max-w-md mx-auto mb-10 lg:mb-0 lg:max-w-none text-left">
              <h2 class="heading font-semibold text-5xl mb-4">
                Bulk Payments — Pay Everyone in One Click.
              </h2>
              <div class="flex flex-col gap-5">
                <div>
                  <p class="text-black text-xl py-2">
                    Payment doesn’t have to be painful.
                  </p>
                  <p class="text-black text-xl">
                    Pay your entire team in minutes — across any bank.
                  </p>
                </div>
                <ul class="space-y-2 text-black">
                  <li class="flex gap-x-2 items-center">
                    <img src="../eazi-landing/assets/circle-check.svg?url" alt="check" class="block">
                    <span class="text-[18px] xl:text-xl"> No limits. No delays.</span>
                  </li>
                  <li class="flex gap-x-2 items-center">
                    <img src="../eazi-landing/assets/circle-check.svg?url" alt="check" class="block">
                    <span class="text-[18px] xl:text-xl">Just a small monthly subscription.</span>
                  </li>
                </ul>

                <p class="text-black text-[18px] xl:text-xl italic">
                  “It’s payroll, but we make it effortless.”
                </p>

                <div class="w-[300px]">
                  <a href="https://www.myeazipay.com/register?page=1" class="link-btn w-[180px]">
                    Get Started Now
                  </a>
                  <!-- <SiteButton color="primary" shadow to="/register?page=1">
                    Get Started Now
                  </SiteButton> -->
                </div>
              </div>
            </div>
            <div>
              <img src="./assets/asset3.png" />
            </div>
          </div>
        </div>
      </section>

      <section class="filing-section py-12 lg:py-20 mt-10">
        <div class="l-container">
          <div class="flex flex-col lg:grid grid-cols-2 lg:gap-16 items-center">
            <div>
              <img src="./assets/asset4.png" />
            </div>
            <div class="max-w-md mx-auto mb-10 lg:mb-0 lg:max-w-none lg:text-left">
              <h2 class="heading font-semibold text-5xl mb-4">Tax Services — We Handle the Headaches</h2>
              <div class="flex flex-col gap-5">
                <p class="text-black text-xl">
                  Stay compliant without lifting a finger.
                </p>
                <ul class="">
                  <li v-for="item in taxServices" :key="item" class="flex gap-x-2 py-2 items-start">
                    <img src="../eazi-landing/assets/circle-check.svg?url" alt="check" class="block mt-1">
                    <span class="text-[18px] xl:text-xl">{{ item }}</span>
                  </li>
                </ul>

                <p class="text-black italic text-[18px] xl:text-xl">
                  “Tax season? You won’t even feel it.”
                </p>

                <div class="w-[300px]">
                  <a href="https://www.myeazipay.com/register?page=1" class="link-btn w-[180px]">
                    Get Started Now
                  </a>
                  <!-- <SiteButton color="primary" shadow to="/register?page=1">
                    Get Started Now
                  </SiteButton> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- <section class="w-full">
      </section> -->

      <section class="why-choose-section py-12 lg:py-20 lg:pb-28">
        <div class="l-container">
          <div class="flex flex-col lg:grid grid-cols-2 lg:gap-16 items-center">
            <div class="sm:w-10/12 md:max-w-md mx-auto mb-10 lg:mb-0 lg:max-w-none lg:text-left">
              <h2 class="heading font-semibold text-4xl mb-4 leading-[45px]">
                Power up your Business with features built for real teams and real leaders.
              </h2>
              <ul class="mb-6 text-black">
                <li v-for="item in teamFeatures" :key="item" class="flex gap-x-2 py-2 items-start">
                  <img src="../eazi-landing/assets/circle-check.svg?url" alt="check" class="block mt-1">
                  <span class="text-[18px] xl:text-xl">{{ item }}</span>
                </li>
              </ul>

              <span class="hidden md:block">
                <a href="https://www.myeazipay.com/register?page=1" class="link-btn w-[150px]">
                  Get Started Now
                </a>
                <!-- <SiteButton color="primary" shadow to="/register?page=1"> Get started </SiteButton> -->
              </span>


            </div>
            <div class="md:w-full">
              <div class="w-full">
                <h2 class="heading font-semibold text-5xl  mb-4">
                  What You Get
                </h2>
                <ul class="mb-6 text-black">
                  <li v-for="item in whatYouGet" :key="item" class="flex gap-x-2 py-2 items-start">
                    <img src="../eazi-landing/assets/circle-check.svg?url" alt="check" class="block mt-1">
                    <span class="text-[18px] xl:text-xl">{{ item }}</span>
                  </li>
                </ul>

                <p class="text-black text-[18px] xl:text-xl w-4/5 mb-4 md:mb-6">
                  **PAYE and Pension and Other compliance may attract additional fees.
                </p>
              </div>

            </div>


          </div>
        </div>
      </section>
    </div>
    <EaziFooter />
  </div>
</template>

<script setup>
import InfinitScrollVue from "../../components/InfinitScroll.vue";
import IconCard from "../../components/IconCard.vue";
import SiteButton from "../../components/SiteButton.vue";
import HeaderBox from "../eazi-landing/ui/HeaderBox.vue";
import EaziFooter from "../eazi-landing/EaziFooter.vue";

const instantSalary = [
  "No more loan sharks. No more stress.",
  "When emergencies hit, employees shouldn’t have to turn to predatory loan apps or informal lenders.",
  "With Eazipay’s Instant Salary Advance, they can access part of their earned salary — right when they need it."
];

const infoList = [
  {
    title: "No HR delays",
    color: "secondary",
  },
  {
    title: "No paperwork",
    color: "primary",
  },
  {
    title: "Fully automated and payroll-synced",
    color: "secondary",
  },
];

const personalCredit = [
  "Zero interest for 30 days",
  "Just a small monthly subscription",
  "No paperwork, no stress",
  "Built for decision-makers"
]

const taxServices = [
  "Auto-calculate tax.",
  "Generate tax reports.",
  "File on time, every time."
]

const teamFeatures = [
  "Activate Salary Advance instantly.",
  "Get a Credit Card Today.",
  "Start for free. No commitments."
]

const whatYouGet = [
  "Ability to pay up to 20 Employees at zero subscription cost",
  "Up to 4 Admin Users (CEO, HR, Finance, Admin)",
  "Zero Monthly Subscription Fees",
  "Only NIP Transaction Charges apply",
]
</script>

<style lang="scss" scoped>
@import url("../../styles/www.scss");

.hero {
  .heading {
    color: #292a29;
  }
}

.filing-section {
  background: #f8f8f8;

  .heading {
    font-family: "MADE Mellow", sans-serif;

    span {
      color: #ea4e4b;
    }
  }
}

.why-choose-section {
  .heading {
    font-family: "MADE Mellow", sans-serif;
  }
}

.link-btn {
  @apply rounded-3xl bg-primary shadow-md text-white grid place-items-center px-3 h-[46px];
}
</style>
